import { RouteObject } from 'react-router-dom';
import { appPaths } from 'consts/paths/paths';
import { EnrollmentEditPage, EnrollmentPage } from 'pages/app/staff/enrollment';

export const enrollmentRoutes: RouteObject[] = [
    {
        path: appPaths.app.enrollment.base,
        element: (
            // TODO add corresponding permission
            // <AbilityRoute can={{ action: AppActions.VIEW, subject: PERMISSIONS_NAME. }}>
            <EnrollmentPage />
            // </AbilityRoute>
        ),
    },
    {
        path: appPaths.app.enrollment.edit.pickedEnrollmentItem,
        element: (
            // TODO add corresponding permission
            // <AbilityRoute can={{ action: AppActions.VIEW, subject: PERMISSIONS_NAME. }}>
            <EnrollmentEditPage />
            // </AbilityRoute>
        ),
    },
];
